<template>
  <div class="sm:flex sm:justify-between sm:items-center my-4 py-4 border-t border-t-vp-base-300 w-full">
    <div class="flex flex-col gap-2 sm:flex-row px-8 sm:px-0 fixed bottom-0 left-0 right-0 bg-vp-base-100 sm:static">
      <VPButton
        v-if="showCancel"
        type="button"
        theme="primary"
        variant="outline"
        class="mb-2 sm:mb-0 sm:px-10 min-w-full sm:min-w-30"
        @click="emit('cancel')"
      >
        Cancel
      </VPButton>

      <VPButton
        v-if="showSave"
        theme="primary"
        variant="solid"
        class="mb-2 sm:mb-0 sm:px-10 min-w-full sm:min-w-30"
        @click="emit('save')"
      >
        Save
      </VPButton>
    </div>
    <VPButton
      v-if="showDelete"
      type="button"
      variant="text"
      class="py-2 px-4"
      @click="emit('delete')"
    >
      <TrashCanOutline class="mr-1 mt-0.5" />
      Delete
    </VPButton>
  </div>
</template>

<script setup lang="ts">
import VPButton from '@/components/form/VPButton.vue';
import { TrashCanOutline } from 'mdue';

type Props = {
  showSave?: boolean;
  showDelete?: boolean;
  showCancel?: boolean;
};

defineProps<Props>();

const emit = defineEmits<{
  (e: 'save'): void;
  (e: 'delete'): void;
  (e: 'cancel'): void;
}>();
</script>
